export const OKTA_NOT_FOUND = 'E0000007';